import Icon from '../components/Icon.vue'

Icon.register({
  'money-bill-wave-alt': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M621.2 54.5c11.6 4.9 18.8 16.8 18.8 29.5v317.3c0 18.5-15 31.8-32.3 31.8-3.4 0-6.9-0.5-10.3-1.6-30.9-9.8-61.8-13.7-92.7-13.7-123.2 0-246.3 62.3-369.5 62.3-38.8 0-77.6-6.2-116.4-22.5-11.6-4.9-18.8-16.8-18.8-29.5v-317.3c0-18.5 15-31.8 32.3-31.8 3.4 0 6.9 0.5 10.3 1.6 30.9 9.8 61.8 13.7 92.7 13.7 123.2 0 246.3-62.3 369.5-62.3 38.8 0 77.6 6.2 116.4 22.5zM320 352c44.2 0 80-43 80-96 0-53-35.8-96-80-96s-80 43-80 96c0 53 35.8 96 80 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/money-bill-wave-alt.js
// module id = 1578
// module chunks = 0